import constants from '../constants.js';


const FlyAmericaNameLabel = { dataAt: 'Name', displayAs: constants.DISPLAY_AS.SUB_HEADING, label: 'Name:' };

const USCarriers = {
  displayName: 'US Carriers',
  dataAt: 'USCarrierCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ModifiedOn = {
  displayName: 'Modified on',
  dataAt: 'ModifiedOn',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ModifiedBy = {
  displayName: 'Modified by',
  dataAt: 'ModifiedBy',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CreatedOn = {
  displayName: 'Created on',
  dataAt: 'CreatedOn',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CreatedBy = {
  displayName: 'Created by',
  dataAt: 'CreatedBy',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const UploadedBy = {
  displayName: 'Uploaded by',
  dataAt: 'UploadedBy',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const UploadedWhen = {
  displayName: 'Uploaded On',
  dataAt: 'UploadedWhen',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const IsDeleted = {
  displayName: 'Delete',
  dataAt: 'IsDeleted',
  disabled: false,
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const FlyAmericaId = {
  displayName: 'Id',
  dataAt: 'Id',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};




const CarrierCodes = {
  displayName: 'CarrierCodes',
  dataAt: 'CarrierCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const CountryCodes = {
  displayName: 'CountryCodes',
  dataAt: 'CountryCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
}

const ConditionalApply = {
  displayName: 'ConditionalApply',
  dataAt: 'ConditionalApply',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'ConditionalApplyTypes'
}

const ApplyCityPairProgram = {
  displayName: 'ApplyCityPairProgram',
  dataAt: 'ApplyCityPairProgram',
  displayAs: constants.DISPLAY_AS.BOOLEAN
}

const ValidFrom = {
  displayName: 'From',
  dataAt: 'ValidFrom',
  disabled: false,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ValidTo = {
  displayName: 'To',
  dataAt: 'ValidTo',
  disabled: false,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const UploadedRouteCount = {
  displayName: 'Count',
  dataAt: 'UploadedRouteCount',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const FlyAmericaConfigOpenSkiesName = {
  displayName: 'Name',
  dataAt: 'OpenSkies.$OpenSkiesItem.Name',
  displayAs:constants.DISPLAY_AS.TEXT_INPUT,
  disabled: false,
};

const FlyAmericaConfigOpenSkiesCountryCodes = {
  displayName: 'Country Codes',
  dataAt: 'OpenSkies.$OpenSkiesItem.CountryCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  disabled: false,
};

const FlyAmericaConfigOpenSkiesCarrierCodes = {
  displayName: 'Carrier Codes',
  dataAt: 'OpenSkies.$OpenSkiesItem.CarrierCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  disabled: false,
};

const FlyAmericaConfigOpenSkiesApplyCityPairProgram = {
  displayName: 'Apply City Pair Program',
  dataAt: 'OpenSkies.$OpenSkiesItem.ApplyCityPairProgram',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  disabled: false,
};

const FlyAmericaConfigOpenSkiesConditionalApply = {
  displayName: 'Conditional Apply',
  dataAt: 'OpenSkies.$OpenSkiesItem.ConditionalApply',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'ConditionalApplyTypes',
  disabled: false,
};

const OpenSkiesItemResource = {
  displayName: 'Open Skies Agreement',
  dataAt: 'OpenSkies.$OpenSkiesItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    FlyAmericaConfigOpenSkiesName,
    FlyAmericaConfigOpenSkiesCountryCodes,
    FlyAmericaConfigOpenSkiesCarrierCodes,
    FlyAmericaConfigOpenSkiesApplyCityPairProgram,
    FlyAmericaConfigOpenSkiesConditionalApply
  ],
  showBack: false, // Show the Back button. This will hide the other buttons in lbaResource.
  endpoint: "FlyAmericaConfigs",
  routeParamId: 'id',
  removeParamId: 'OpenSkiesItem',
  canDelete: true
};

const OpenSkiesList = {
  displayName: 'Open Skies',
  iconClass: 'fa-plane',
  dataAt: 'OpenSkies',
  canAddNew: true,
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: OpenSkiesItemResource,
  gridCols: [{ name: 'Name', key: 'Name' },{ name: 'Country Codes', key: 'CountryCodes' }, { name: 'Carrier Codes', key: 'CarrierCodes' }]
};


const FlyAmericaPolicyExceptionsTitle = {
  displayName: 'Title',
  dataAt: 'DefaultFlyAmericaPolicyExceptions.$DefaultFlyAmericaPolicyExceptionsItem.Title',
  displayAs:constants.DISPLAY_AS.TEXT_INPUT,
  disabled: false,
};
const FlyAmericaPolicyExceptionsCode = {
  displayName: 'Code',
  dataAt: 'DefaultFlyAmericaPolicyExceptions.$DefaultFlyAmericaPolicyExceptionsItem.Code',
  displayAs:constants.DISPLAY_AS.TEXT_INPUT,
  disabled: false,
};

const DefaultFlyAmericaPolicyExceptionsItemResource = {
  displayName: 'Fly America Policy Exception',
  dataAt: 'DefaultFlyAmericaPolicyExceptions.$DefaultFlyAmericaPolicyExceptionsItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [FlyAmericaPolicyExceptionsTitle, FlyAmericaPolicyExceptionsCode],
  showBack: false, // Show the Back button. This will hide the other buttons in lbaResource.
  endpoint: "FlyAmericaConfigs",
  routeParamId: 'id',
  removeParamId: 'DefaultFlyAmericaPolicyExceptionsItem',
  canDelete: true
};

const DefaultFlyAmericaPolicyExceptionsList = {
  displayName: 'Default Fly America Policy Exceptions',
  iconClass: 'fa-plane',
  dataAt: 'DefaultFlyAmericaPolicyExceptions',
  canAddNew: true,
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: DefaultFlyAmericaPolicyExceptionsItemResource,
  gridCols: [{ name: 'Code', key: 'Code' },{ name: 'Title', key: 'Title' }]
};


const ProgramRouteFileUpload = {
  displayName: 'City Pair Program File Upload',
  dataAt: 'ProgramRouteFileUpload',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'ProgramRouteFileUpload',
  uploadType: 'xlsx',
  fileNamePrefix: 'ProgramRoutesFile',
  fileNameFormat: 'yyyymmdd',
  excludeFromPost: true,
  fileAccept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
};

const ProgramRouteFileDownload = {
  displayName: 'City Pair Program File Download',
  dataAt: 'ProgramRouteFileDownload',
  displayAs: constants.DISPLAY_AS.FILE_DOWNLOADER,
  fileNameSuffix: 'ProgramRoutes.xlsx',
  parameterValueFromActiveItemProperty: 'Id',
  parameterName: 'Id',
  endPointController: 'ProgramRouteDownload'
};

const FlyAmericaConfigCityPairProgramOrigin = {
  displayName: 'Origin',
  dataAt: 'CityPairProgram.$FlyAmericaCityPairItem.Origin',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: false,
};

const FlyAmericaConfigCityPairProgramDestination = {
  displayName: 'Destination',
  dataAt: 'CityPairProgram.$FlyAmericaCityPairItem.Destination',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: false,
};

const FlyAmericaConfigCityPairProgramValidFrom = {
  displayName: 'Valid From',
  dataAt: 'CityPairProgram.$FlyAmericaCityPairItem.ValidFrom',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: false,
};


const FlyAmericaConfigCityPairProgramValidTo = {
  displayName: 'Valid To',
  dataAt: 'CityPairProgram.$FlyAmericaCityPairItem.ValidTo',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: false,
};

const CityPairProgram = {
  displayName: 'City Pair Program',
  dataAt: 'CityPairProgram',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: CityPairProgramItem,
  gridCols:
    [{name: 'Origin', key: 'Origin' },
    { name: 'Destination', key: 'Destination' },
    { name: 'ValidFrom', key: 'ValidFrom' },
    { name: 'ValidTo', key: 'ValidTo' }]
};
const CityPairProgramItem = {
  displayName: 'City Pair',
  dataAt: 'CityPairProgram.$CityPairProgramItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [FlyAmericaTabs, FlyAmericaConfigCityPairProgramOrigin, FlyAmericaConfigCityPairProgramDestination, FlyAmericaConfigCityPairProgramValidFrom, FlyAmericaConfigCityPairProgramValidTo],
  showBack: false,// Show the Back button. This will hide the other buttons in lbaResource.
  endpoint: "FlyAmericaConfigs",
  routeParamId: 'flyAmericaId',
  removeParamId: 'FlyAmericaCityPairItem',
  canDelete: true
};




const ProgramRouteItemResource = {
  rootNode: true,
  displayName: 'FlyAmericaConfigs',
  dataAt: '',
  //dataAt: 'ProgramRoutes.$ProgramRoutesItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [FlyAmericaId,  ValidFrom, ValidTo, UploadedBy, UploadedWhen, ProgramRouteFileDownload, UploadedRouteCount, CityPairProgram, IsDeleted],
  showBack: false,// Show the Back button. This will hide the other buttons in lbaResource.
  endpoint: "FlyAmericaConfigs",
  routeParamId: 'id',
  removeParamId: 'removeId'
};

const ProgramRouteAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'FlyAmericaConfigs',
  data:
  {
    Name: ''
  },
  dataAt: '',
  children: [FlyAmericaNameLabel, FlyAmericaId],
  endpoint: "FlyAmericaConfigs"
  //endpoint: "FlyAmericaConfigs$filter=DocType eq 'OpenSkies'"
};

const ProgramRoutesList = {
  rootNode: true,
  displayName: 'City Pair Program',
  //dataAt: 'ProgramRoutes',
  iconClass: 'fa-plane',
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: ProgramRouteItemResource,
  gridAdd: ProgramRouteAddResource,
  canAddNew: true,
  ODataArgs: "?$filter=DocType eq 'CityPairProgram'",
  //ODataArgs: '?$select=Id,Name,Title,ConsultingTeamEmail,DebtorApprovalLevel,Disabled$&$filter=DocType eq 'ProgramRoute'',
  endpoint: "FlyAmericaConfigs",
  gridCols: [{ name: 'From', key: 'ValidFrom' },{ name: 'To', key: 'ValidTo' }, { name: 'Count', key: 'UploadedRouteCount' },{ name: 'Uploaded by', key: 'UploadedBy' },{ name: 'Uploaded On', key: 'UploadedWhen' }]
};

const FlyAmericaActConfigPanel = {
  dataAt: '',
  tabName: 'Fly-America-Config',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [FlyAmericaId, USCarriers, OpenSkiesList,DefaultFlyAmericaPolicyExceptionsList]
};



const ProgramRoutePanel = {
  dataAt: '',
  tabName: 'City-Pair-Program',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ProgramRouteFileUpload, 
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label: "Excel Files Only. Required columns are shown below"
    },
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label: "Option 1 [Origin, Destination, ValidFrom, ValidTo]"
    },
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label: "Option 2 [ORIGIN_AIRPORT_ABBREV, DESTINATION_AIRPORT_ABBREV, EFFECTIVE_DATE, EFFECTIVE_DATE]"
    },
    ProgramRoutesList]
};



const AdminPanel = {
  tabName: 'Admin',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [CreatedBy, CreatedOn, ModifiedBy, ModifiedOn]
};

const FlyAmericaTabs = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.TABS,
  children: [FlyAmericaActConfigPanel, ProgramRoutePanel]
};

const ProgramRouteTabs = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.TABS,
  children: [ProgramRoutePanel, AdminPanel]
};

const CarriersResource = {
  rootNode: true,
  displayName: 'FlyAmericaConfigs',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: '',
  children: [FlyAmericaTabs, FlyAmericaActConfigPanel],
  showBack: false,// Show the Back button. This will hide the other buttons in lbaResource.
  endpoint: 'FlyAmericaConfigs',
  routeParamId: "id"
};



const ProgramRouteResource = {
  rootNode: true,
  displayName: "FlyAmericaConfigs",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: '',
  children: [FlyAmericaTabs],
  showBack: false,// Show the Back button. This will hide the other buttons in lbaResource.
  endpoint: "FlyAmericaConfigs?$filter=DocType eq 'ProgramRoute'"
};
// const ProgramRouteResource = {
//   rootNode: true,
//   displayName: "FlyAmericaConfigs",
//   displayAs: constants.DISPLAY_AS.RESOURCE,
//   dataAt: '',
//   children: [FlyAmericaTabs],
//   showBack: false,// Show the Back button. This will hide the other buttons in lbaResource.
//   endpoint: "FlyAmericaConfigs"
// };

export default {
  FlyAmericaId,
  USCarriers,
  FlyAmericaActConfigPanel,
  FlyAmericaTabs,
  //OpenSkiesAddResource,
  OpenSkiesItemResource,
  CarriersResource,
  CountryCodes,
  CarrierCodes,
  ApplyCityPairProgram,
  ConditionalApply,
  FlyAmericaNameLabel,
  ProgramRouteFileUpload,
  ProgramRoutePanel,
  ProgramRouteResource,
  ProgramRouteFileDownload,
  ProgramRouteItemResource,
  ProgramRouteAddResource,
  CityPairProgram,
  CityPairProgramItem,
  FlyAmericaConfigCityPairProgramOrigin,
  FlyAmericaConfigCityPairProgramDestination,
  FlyAmericaConfigCityPairProgramValidFrom,
  FlyAmericaConfigCityPairProgramValidTo,
  OpenSkiesList,
  FlyAmericaConfigOpenSkiesName,
  FlyAmericaConfigOpenSkiesCountryCodes,
  FlyAmericaConfigOpenSkiesCarrierCodes,
  FlyAmericaConfigOpenSkiesApplyCityPairProgram,
  FlyAmericaConfigOpenSkiesConditionalApply,
  DefaultFlyAmericaPolicyExceptionsList,
  DefaultFlyAmericaPolicyExceptionsItemResource,
  FlyAmericaPolicyExceptionsTitle,
  FlyAmericaPolicyExceptionsCode,
  UploadedBy,
  UploadedWhen,
  IsDeleted,
  ValidFrom,
  ValidTo,
  UploadedRouteCount
}


// WEBPACK FOOTER //
// ./src/config/fields/flyAmericaAct.js